export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Number of employees",
        tax_identifier: "Company ID (IDE)",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Sales rep",
        email: "Email",
        budget: "Budget",
        event_types: "Event types",
        distance_km: "Distance to the venue (km)",
        lead_score: "Lead score",
        acquisition_channel: "Acquisition channel",
        prospect_state: "Prospect state",
        customer_status: "Status",
        last_contact_date: "Last contact",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
        prospection: "Prospecting",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      quotes: {
        title: "Quotes",
        upload: "Add a PDF",
        empty: "No quote yet.",
        added: "Quote added",
        deleted: "Quote deleted",
        upload_error: "The quote could not be uploaded",
        invalid_file: "%{name} was not added: PDF files of %{max} MB at most.",
        delete: "Delete %{name}",
        delete_title: "Delete this quote?",
        delete_content: "%{name} will be deleted for good.",
      },
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
        lead_score: "Lead score",
        main_company: "Main company",
        company_ids: "Other companies",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        removed:
          "Tag removed from %{smart_count} contact |||| Tag removed from %{smart_count} contacts",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Event type",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
        status: "Status",
      },
      statuses: {
        open: "Open",
        late: "Late",
        won: "Won",
        lost: "Lost",
      },
      staff: {
        tab: "Staff",
        add: "Add staff",
        search: "Search a name",
        no_match: "No partner found",
        empty: "No staff yet.",
        remove: "Remove %{name}",
        save_error: "The staff could not be updated",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        password: "Password",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        disabled: "Disabled",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        success_with_password:
          "User created. They can sign in now with this password.",
        password_helper:
          "Optional. Leave empty to send an invitation email instead.",
        password_too_short: "The password must be at least 8 characters long.",
        show_password: "Show the password",
        hide_password: "Hide the password",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Task",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        company_id: "Company",
        note: "Note",
        status: "Status",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        abandon: "Abandon",
        reopen: "Reopen",
        mark_done: "Mark as done",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      marked_done: "Task done",
      statuses: {
        todo: "To do",
        done: "Done",
        abandoned: "Abandoned",
      },
      page_statuses: {
        todo: "To do",
        done: "Done",
        abandoned: "Abandoned",
      },
      scopes: {
        mine: "My tasks",
        all: "All tasks",
      },
      validation: {
        contact_or_company: "Choose a contact or a company",
      },
      updated: "Task updated",
    },
    events: {
      name: "Event |||| Events",
      fields: {
        name: "Event name",
        type: "Type",
        start_at: "Start",
        end_at: "End",
        organizer_name: "Organizer",
        price: "Price",
        deliverables: "Deliverables",
        company_id: "Company",
        contact_id: "Contact",
        deal_id: "Opportunity",
        partner_ids: "Staff and partners",
      },
      action: {
        add: "Add event",
        create: "New event",
        delete: "Delete event",
      },
      dialog: {
        create: "New event",
        create_for: "New event for %{name}",
        edit: "Edit event",
      },
      views: {
        calendar: "Calendar",
        list: "List",
      },
      calendar: {
        today: "Today",
        previous_month: "Previous month",
        next_month: "Next month",
      },
      list: {
        upcoming: "Upcoming",
        past: "Past",
        empty: "No event",
        for: "For",
      },
      deal_staff: "Opportunity staff",
      added: "Event added",
      updated: "Event updated",
      deleted: "Event deleted",
      validation: {
        company_or_contact: "Choose a company or a contact",
        end_after_start: "The end must be after the start",
      },
    },
    partners: {
      name: "Partner |||| Partners",
      fields: {
        name: "Name",
        category: "Category",
        type: "Type",
        phone: "Phone",
        email: "Email",
        organisation: "Company / organisation",
        background: "Notes",
        linked_sales_id: "OPTICERCLE account",
      },
      categories: {
        staff: "Staff",
        partner: "Partner",
      },
      action: {
        new: "New partner",
        edit: "Edit partner",
      },
      details: "Details",
      no_deals: "Not on any opportunity yet.",
      add_to_deal: "Add to an opportunity",
      add_to_event: "Add to an event",
      search_deal: "Search an opportunity",
      search_event: "Search an event",
      remove_from: "Remove from %{name}",
      via_deal: "via %{name}",
      link_error: "The link could not be saved",
      no_linked_account: "None",
      linked_sales_help:
        "Team member with an account: their events go straight into their connected calendar.",
      no_events: "No event yet.",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
      empty: "No tags yet.",
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to OPTICERCLE",
    },
    mailbox: {
      title: "Mailbox",
      new: "New message",
      not_connected: "Connect your mailbox first to read it here.",
      folder: "Folder",
      folders: {
        inbox: "Inbox",
        drafts: "Drafts",
        sent: "Sent",
        archive: "Archive",
        junk: "Junk",
        trash: "Trash",
      },
      messages: "Messages",
      search: "Search (sender, recipient, subject)",
      loading: "Loading…",
      load_error: "The mailbox could not be read. Try again in a moment.",
      empty: "No message in this folder.",
      no_match: "No message matches.",
      select: "Pick a message to read it.",
      range: "%{first}–%{last} of %{total}",
      newer: "Newer messages",
      older: "Older messages",
      to_recipients: "To: %{recipients}",
      from: "From",
      date: "Date",
      reply: "Reply",
      reply_all: "Reply all",
      forward: "Forward",
      delete: "Delete",
      delete_confirm: "Move this message to the trash?",
      delete_forever_confirm: "Delete this message for good?",
      deleted: "Message deleted",
      quote_header: "On %{date}, %{name} wrote:",
      forwarded: "---------- Forwarded message ----------",
      attachments: "Attachments",
      download: "Download %{name}",
      in_crm: "In the CRM",
      no_record: "No CRM record matches these addresses.",
      in_feed: "Already in the feed",
      add_to_feed: "Add to the feed",
      added_to_feed: "Email added to the feed",
      add_dialog: {
        title: "Add to the activity feed",
        help: "The email joins the feed of the chosen records, visible to the whole team. Contacts and partners known by their address are added anyway.",
        company: "Choose a company",
        contact: "Choose a contact",
        search: "Search",
        remove: "Remove %{name}",
        confirm: "Add",
      },
    },
    billing: {
      title: "Subscription",
      activate: "Activate the subscription",
      pay: "Pay now",
      reactivate: "Reactivate the subscription",
      manage: "Manage my subscription",
      refresh: "Refresh",
      refreshed: "Subscription up to date",
      plan: "Plan",
      amount: "Amount",
      next_payment: "Next payment",
      ends_on: "Ends on",
      no_subscription:
        "No subscription yet: activate it with the button below.",
      banner: {
        activate: "Your OPTICERCLE subscription is not activated yet.",
        unpaid:
          "The payment of your OPTICERCLE subscription failed. Pay before %{date} to keep access to the CRM.",
        ended:
          "Your OPTICERCLE subscription has ended. Access to the CRM will be suspended on %{date}.",
      },
      blocked: {
        title: "Subscription suspended",
        text: "The payment of the OPTICERCLE subscription was not received. Your data is kept: access comes back as soon as the payment is recorded.",
        paid: "I paid: check",
      },
      statuses: {
        none: "Not activated yet",
        active: "Active",
        trialing: "Trial",
        past_due: "Payment overdue",
        unpaid: "Unpaid",
        paused: "Paused",
        canceled: "Cancelled",
        incomplete: "Payment pending",
        incomplete_expired: "Payment expired",
      },
      errors: {
        unavailable:
          "The payment service does not answer. Try again in a moment.",
      },
    },
    calendar: {
      title: "Staff calendars",
      resync: "Update the calendars",
      synced: "Staff calendars updated",
      sender_not_connected:
        "Staff invitations not sent: connect your mailbox in « Mail and calendar ».",
      some_failed:
        "A staff member could not be notified |||| %{smart_count} staff members could not be notified",
      sync_failed: "The staff calendars could not be updated.",
      state: {
        in_calendar: "In their calendar",
        invited: "Invitation sent to %{email}",
        pending: "Not sent yet",
        unreachable: "No email nor OPTICERCLE account: complete their page",
      },
      errors: {
        sender_not_connected: "Invitation waiting: mailbox not connected",
        auth_failed: "Access denied: check the password",
        unreachable: "Server unreachable, try again later",
        calendar_not_connected: "Their calendar is no longer connected",
        unknown: "Sending failed",
      },
    },
    mail: {
      title: "Mail and calendar",
      intro:
        "Connect your Infomaniak mailbox and calendar: send emails from the records, find your exchanges in the activity feed and get the events in your calendar.",
      test: "Test the connection",
      tested: "Connection checked",
      checking: "Checking...",
      disconnect: "Disconnect",
      mailbox: {
        title: "Mailbox",
        help: "On config.infomaniak.com (or in the Infomaniak Manager, Mail Service → your address), create a password for OPTICERCLE only. You can delete it at any time without touching the one of Outlook.",
        connected_as: "Connected: %{email}",
        email: "Email address",
        password: "Mail password",
        password_keep: "Leave empty to keep the saved password",
        advanced: "Servers (Infomaniak by default)",
        imap_host: "IMAP server",
        imap_port: "IMAP port",
        smtp_host: "SMTP server",
        smtp_port: "SMTP port",
        connect: "Connect the mailbox",
        update: "Save",
        saved: "Mailbox connected",
        disconnected: "Mailbox disconnected",
        history_running:
          "Importing the emails of the last 12 months: they show on the records as they come.",
        last_sync: "Emails fetched %{date} (every 5 minutes)",
        sync_now: "Fetch now",
        sync_started: "Fetching: the new emails arrive in a moment.",
        status: {
          connected: "Connected",
          disconnected: "Not connected",
          error: "Error",
        },
      },
      calendar: {
        title: "Calendar",
        help: "On config.infomaniak.com, choose to sync on this device, then contacts and calendars, « Manual synchronisation » tab: it shows your username (e.g. AB12345) and a « Generate » button for the app password.",
        connected_to: "Calendar: %{name}",
        username: "Sync username",
        password: "App password",
        connect: "Connect",
        choose: "Pick the calendar OPTICERCLE writes the events to",
        none: "No calendar found on this account.",
        use: "Use this calendar",
        change: "Change calendar",
        saved: "Calendar connected",
        disconnected: "Calendar disconnected",
        status: {
          connected: "Connected",
          disconnected: "Not connected",
          pending: "Calendar to pick",
          error: "Error",
        },
      },
      signature: {
        title: "Signature",
        help: "Added at the end of the emails sent from OPTICERCLE.",
        text: "Signature text",
        image: "Add a picture (logo)",
        image_invalid: "Pick a picture of 2 MB at most.",
        remove_image: "Remove the picture",
        save: "Save the signature",
        saved: "Signature saved",
      },
      compose: {
        title: "New email",
        open: "Send an email",
        from: "From %{email}",
        to: "To",
        cc: "Cc",
        bcc: "Bcc",
        add_copies: "Add Cc / Bcc",
        template: "Template",
        template_placeholder: "Pick a template (optional)",
        subject: "Subject",
        body: "Message",
        add_file: "Attach a file",
        attach_quote: "Attach « %{name} »",
        remove_file: "Remove %{name}",
        remove_recipient: "Remove %{email}",
        send: "Send",
        sending: "Sending...",
        sent: "Email sent",
        not_connected:
          "Connect your mailbox first: emails leave from your own address.",
        connect: "Connect my mailbox",
      },
      emails: {
        tab: "Emails",
        you: "You",
        sent_by: "%{name} wrote to %{recipients}",
        received_from: "%{name} wrote",
        cc: "Cc: %{recipients}",
        no_subject: "(no subject)",
        reply: "Reply",
        empty: "No email yet.",
        create_contact: "Create the contact",
        attachment_in_mailbox: "Attachment to open in your mailbox",
      },
      errors: {
        invalid_recipient: "Invalid email address.",
        missing_recipient: "Add at least one recipient.",
        too_many_recipients: "Too many recipients (50 at most).",
        missing_subject: "Enter a subject.",
        subject_too_long: "Subject too long.",
        body_too_long: "Message too long.",
        invalid_attachment: "This attachment cannot be sent.",
        attachment_not_found: "An attachment could not be found.",
        attachments_too_large: "Attachments too large (20 MB in all at most).",
        mailbox_not_connected: "Connect your mailbox first.",
        invalid_folder: "This folder no longer exists in the mailbox.",
        invalid_uid: "This message cannot be found.",
        message_not_found: "This message is no longer in the mailbox.",
        attachment_too_large:
          "File too large to open here: open it in your webmail.",
        auth_failed: "The server refused the username or the password.",
        unreachable: "Server unreachable: check its address and port.",
        invalid_email: "Invalid email address.",
        missing_password: "Enter the password.",
        missing_username: "Enter the username.",
        invalid_port: "Invalid port.",
        missing_calendar: "Pick a calendar.",
        unknown_calendar: "This calendar no longer exists.",
        calendar_not_connected: "Connect the calendar first.",
        signature_too_long: "Signature too long (2000 characters at most).",
        unknown: "Something went wrong. Please try again.",
      },
    },
    filters: {
      search: "Search...",
      no_match: "No match",
      clear: "Clear",
      stars: "%{smart_count} star |||| %{smart_count} stars",
      recent_activity: "Recent activity",
      inactive: "No activity",
      this_month: "This month",
    },
    common: {
      account_manager: "Account manager",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
      to_define: "To be defined",
      lead_score_at_least:
        "%{smart_count} star or more |||| %{smart_count} stars or more",
      view_table: "Table view",
      view_cards: "Card view",
      view_kanban: "Kanban view",
      view_list: "List view",
    },
    custom_fields: {
      title: "Custom fields",
      types: {
        text: "Short text",
        long_text: "Long text",
        number: "Number",
        currency: "Amount",
        date: "Date",
        select: "Dropdown list",
        multi_select: "Multiple choice",
        boolean: "Yes / No",
        rating: "Rating (1 to 5)",
        url: "Link",
      },
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      upcoming_events: "Upcoming events",
      no_upcoming_events: "No upcoming event",
      see_all: "See all",
      kpis: {
        open_deals: "Open opportunities",
        upcoming_events: "Upcoming events",
        late_tasks: "Overdue tasks",
        new_prospects: "New prospects",
        next_days: "Next %{smart_count} days",
        last_days: "Last %{smart_count} days",
        mine: "Assigned to me",
      },
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install OPTICERCLE",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    welcome: {
      slogan: "Prospect. Close. Fill the Cercle.",
    },
    spreadsheet: {
      groups: {
        identity: "Identity",
        prospecting: "Prospecting",
        contact: "Contact details",
        address: "Address",
        follow_up: "Follow-up",
        custom: "Custom fields",
      },
      columns: {
        gender: "Pronouns",
        status: "Status",
        tags: "Tags",
        email_work: "Work email",
        email_home: "Personal email",
        email_other: "Other email",
        phone_work: "Work phone",
        phone_home: "Personal phone",
        phone_other: "Other phone",
        first_seen: "First contact",
      },
      hints: {
        list: "Several values allowed: separate them with commas.",
        company: "Exact company name; it is created if it does not exist yet.",
      },
      export: {
        button: "Export",
        title: "Export to Excel",
        description:
          "%{smart_count} row, with the list filters. Choose the columns to export. |||| %{smart_count} rows, with the list filters. Choose the columns to export.",
        select_all: "Select all",
        select_none: "Select none",
        submit:
          "Export %{smart_count} column |||| Export %{smart_count} columns",
        error: "The export failed. Try again in a moment.",
      },
      template: {
        instructions_sheet: "Instructions",
        lists_sheet: "Lists",
        title: "How to fill in this file",
        step_1:
          "1. Fill in one row per record in the first sheet, from row 3 (row 2 is an example to delete or replace).",
        step_2:
          "2. Columns marked with * are required; the others may stay empty.",
        step_3:
          "3. For list columns, pick a value from the dropdown; the Lists sheet shows every allowed value.",
        step_4:
          "4. Dates as DD.MM.YYYY, amounts as plain numbers without currency, lead score from 1 to 5. Save, then import the file into the CRM.",
        table: {
          column: "Column",
          required: "Required",
          values: "Allowed values / format",
          example: "Example",
        },
        required: "Yes",
        optional: "No",
        kinds: {
          text: "Text",
          long_text: "Long text",
          number: "Number",
          currency: "Amount as a number (no currency)",
          date: "Date (DD.MM.YYYY)",
          datetime: "Date and time",
          choice: "One value from the list",
          choices: "One or more values from the list, separated by commas",
          rating: "Whole number from 1 to 5",
          boolean: "Yes or No",
          phone: "Text (leading zeros are kept)",
        },
        list_prompt: "Pick a value from the list.",
        choices_prompt: "Pick a value, or type several separated by commas.",
        rating_error: "Enter a whole number from 1 to 5.",
        list_error: "Pick a value from the dropdown (see the Lists sheet).",
        number_error: "Enter a positive number, without currency.",
        date_error: "Enter a date as DD.MM.YYYY.",
      },
    },
    data_import: {
      button: "Import",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      csv_file: "Excel or CSV file",
      error:
        "Failed to import this file, please make sure you provided a valid Excel (.xlsx) or CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download the Excel template",
      sample_hint:
        "Start from the Excel template: it has the expected columns, the dropdown lists and instructions.",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    search: {
      title: "Search",
      placeholder: "Search contacts, companies, deals, tasks and notes...",
      hint: "Type at least %{min} characters to search",
      empty: "No result found",
      error: "Search is unavailable right now. Please try again.",
      untitled_result: "(no title)",
      groups: {
        contacts: "Contacts",
        companies: "Companies",
        deals: "Deals",
        tasks: "Tasks",
        contact_notes: "Contact notes",
        deal_notes: "Deal notes",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      email_templates: {
        title: "Email templates",
        help: "Texts offered in the compose window, for the whole team. Placeholders: {{prenom}}, {{nom}}, {{entreprise}}, {{mon_prenom}}, {{mon_nom}}. The sender's signature is added after the text.",
        name: "Template name",
        subject: "Subject",
        body: "Text",
      },
      partners: {
        staff_types: "Staff types",
        partner_types: "Partner types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
        prospection: "Prospecting",
        custom_fields: "Custom fields",
        lead_api: "Lead API",
      },
      lead_api: {
        help: "Lets a website or a tool (Make, Zapier…) send prospects into the CRM. Each call finds or creates the company and the contact, and adds the request to the contact's activity.",
        endpoint: "API address (POST)",
        key: "API key",
        no_key: "No active key: the API rejects every call.",
        key_status: "Active key %{prefix}…, created on %{date}",
        last_used: "Last used on %{date}",
        never_used: "Never used yet",
        generate: "Generate a key",
        regenerate: "Generate a new key",
        regenerate_title: "Replace the API key?",
        regenerate_content: "The current key will stop working immediately.",
        new_key: "Copy this key now: it will not be shown again.",
        generate_error: "Could not generate the key",
        auth_help:
          "Send the key in the X-API-Key header (or Authorization: Bearer). Keep it secret: call the API from a server or an automation tool, never from a web page's code.",
        parameters: "Parameters (JSON body)",
        required: "required",
        example: "Example",
        types: {
          text: "text",
          number: "number",
          date: "date YYYY-MM-DD",
        },
        params: {
          email: "Contact email, used to find an existing contact",
          first_name: "First name",
          last_name: "Last name",
          phone: "Phone number",
          company: "Company name, found by its name or created",
          event_type: "Event type: value or label from the Settings list",
          event_date: "Requested date",
          guests: "Number of guests",
          budget: "Budget in CHF",
          message: "Free text (5000 characters max)",
          source: "Acquisition channel, “Website” by default",
        },
      },
      prospection: {
        event_types: "Event types",
        acquisition_channels: "Acquisition channels",
        prospect_states: "Prospect states",
        customer_statuses: "Prospect statuses",
      },
      custom_fields: {
        help: "Fields added here appear on every record. They are never required: an empty field shows “To be defined”.",
        companies: "Company fields",
        contacts: "Contact fields",
        deals: "Opportunity fields",
        partners: "Partner fields",
        label: "Field name",
        type: "Type",
        options: "Choices",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
      more: "More",
      home: "Home",
    },
    profile: {
      add_secondary_email: "Add an email",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
